import React, { FC, useCallback, useContext, useRef, useState } from 'react';

import Icon from '../Icon';
import LangSelectList from './LangSelectList';
import { LangContext } from '../../providers/LangProvider';

import withMediaQueries from '../MediaQueries';

import UseClickOutSide from '../../uses/useClickOutSide';

import { ILangSelect } from './interfaces';

import { locales } from '../../i18n';

import './styles.scss';

import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';

// lang select
const LangSelect: FC<ILangSelect> = ({
  lang,
  queries
}) => {
  const element: any = useRef<any>(null);
  const [ open, setOpen ] = useState<boolean>(false);
  const { setLang }: any = useContext(LangContext);

  // click out
  UseClickOutSide(element, () => setOpen(false));

  // on handle
  const onHandle = useCallback((e: { value: any; }) => {
    setLang(e.value);
    setOpen(false);
    window.location.reload();
  }, [ setOpen, setLang ]);
  
  // render
  return (
    <div
      className="lang-select"
      onClick={() => setOpen(true)}
      onMouseOut={() => setOpen(false)}
      data-active={open}
      ref={element}>
        
      {(queries === 'lg' || queries === 'md') && 
        <>
        <Dropdown options={locales} onChange={onHandle} value={lang} />
        <Icon icon="icon-arrow-down" />
        </>
      }

      {(queries !== 'lg' && queries !== 'md') &&
        <>
        <button
        className="btn lang-select--btn"
        onClick={() => setOpen(!open)}>
          <Icon icon="icon-arrow-down" />
        </button>

        <div className="lang-select--container">
          <LangSelectList setOpen={setOpen} />
        </div>
        </>
      }
    </div>
  );
};

export default withMediaQueries(LangSelect);